import * as _ from 'underscore'

import { ColumnModel } from '../../modules/api/api.models'

import { OpDataTypeInGroup } from '../../models/core'
import { Enums } from '../../models/common'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'

import { DistributorService } from './distributor.service'
import { DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from '../data-type'
import { GridService, GRID_SERVICE_NAME } from '../grid'



//#region Public Types

export const DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_NAME = 'DistributorExtendedParametersService'
export const DISTRIBUTOR_EXTENDED_PARAMETERS_SERVICE_PROVIDER_NAME = 'DistributorExtendedParametersServiceProvider'

//#endregion


export class DistributorExtendedParametersService {

    //#region Ctor

    public constructor(
        private dataTypeGroupService: DataTypeGroupService,
        private gridService: GridService,
        private userSessionService: UserSessionService
    ) { }

    //#endregion


    public getExtendedParametersDataTypeGroup(): JQueryPromise<OpDataTypeInGroup[]> {
        return this.dataTypeGroupService
            .getDataTypeInGroupByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY,
                DistributorService.SIMAX_MODULE_NAME,
                {
                    groupReferenceType: Enums.ReferenceType.IdDistributor,
                    groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor
                }
            )
    }

    public getExtendedParametersColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService
            .getColumnModelByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS_TO_DISPLAY,
                DistributorService.SIMAX_MODULE_NAME,
                {
                    groupReferenceType: Enums.ReferenceType.IdDistributor,
                    groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor,
                    skipView: true,
                }
            )
    }
}

export class DistributorExtendedParametersServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [DATA_TYPE_GROUP_SERVICE_NAME, GRID_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (
        dataTypeGroupService: DataTypeGroupService,
        gridService: GridService,
        userSessionService: UserSessionService
    ) {
        return new DistributorExtendedParametersService(dataTypeGroupService, gridService, userSessionService)
    }]

    //#endregion
} 